/**
 * Text-page geometry for the project PDF (DSTU 3008-style).
 * Does not apply to the topology drawing sheet (PDF page 1).
 */
export const TEXT_PAGE_LAYOUT_MM = {
  width: 210,
  height: 297,
  left: 30,
  right: 10,
  top: 20,
  bottom: 20,
  firstLineIndent: 10,
} as const;
